<template>
    <div class="route-map-container">
        <div class="route-map-content bg-dark" v-if="routePoints.length > 0">
            <div class="map-wrapper">
                <l-map :options="mapOptions" :zoom="zoom" :center="center" @ready="onMapReady" ref="map">
                    <l-tile-layer :url="url" :attribution="attribution" />
                    <l-icon-default />
                    <l-control-scale position="bottomleft" :imperial="false" :metric="true"></l-control-scale>

                    <div >
                        <l-marker 
                        v-for="(coordenadas, index) in routePoints" 
      :key="index"
                        :icon="updateIconColor(index)" :lat-lng="[
                            coordenadas.latUbicacionEntrega,
                            coordenadas.longUbicacionEntrega,
                        ]" ref="markerRefIni"></l-marker>
                    </div>

                    <l-control position="topright">
                        <vs-button @click.prevent="toggleStyles" :color="modoNocturno ? 'warn' : 'dark'">
                            <i :class="modoNocturno ? 'fa-regular fa-sun' : 'fa-solid fa-moon'" style="width: 15px"></i>
                        </vs-button>
                    </l-control>
                </l-map>
            </div>
            <div class="route-list-wrapper">
                <b-list-group>
                    <b-list-group-item v-for="(rutainfor, index) in routePoints" :key="index" active
                        class="route-item rounded" @click="
                            redirectMap([
                                rutainfor.latUbicacionEntrega,
                                rutainfor.longUbicacionEntrega,
                            ])
                            ">
                        <div class="d-flex flex-wrap w-100 justify-content-between">
                            <h5 class="mb-1 mr-1" :style="updateTextColor(index)">{{ rutainfor.lugarEntrega }}</h5>
                            <small>{{ rutainfor.ubicacion }}</small>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </div>
        <div class="no-points-message" v-else>
            <span class="h1">¡Sin puntos seleccionados!</span>
        </div>
    </div>
</template>

<script>
import {
    LMap,
    LTileLayer,
    LMarker,
    //LPolyline,
    LControlScale,
    LControl,
    LIconDefault,
} from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine";

export default {
    props: {
        routePoints: {
            type: Array,
            required: true,
        },
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        //LPolyline,
        LControlScale,
        LControl,
        LIconDefault,
    },
    data() {
        return {
            map: null,
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution:
                '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 14,
            center: [4.7279077, -74.062912],
            customIconIni: null,

            persona: {},
            empresaId: {},
            contadorProgreso: 0,
            distanciaTotal: 0,
            markers: [],
            mapOptions: {
                //autoClosePopup: false, // Evitar que el mapa cierre automáticamente los popups
            },

            polylineOptions: {
                weight: 5,
            },
            polyLineColors: [
                "#085ec5", // Azul
                "#ee002b", // Rojo
                "#00FF00", // Verde brillante
                "#0000FF", // Azul
                "#FFFF00", // Amarillo
                "#FF00FF", // Magenta
                "#00FFFF", // Cian
                "#800000", // Marrón
                "#808000", // Verde oliva
                "#008080", // Verde azulado oscuro
                "#800080", // Púrpura
                "#FFA500", // Naranja
                "#A52A2A", // Marrón rojizo
                "#7CFC00", // Verde pasto
                "#FFD700", // Dorado
                "#4B0082", // Índigo
                "#DC143C", // Carmesí
                "#FF1493", // Rosa fuerte
                "#20B2AA", // Verde azulado
                "#2E8B57", // Verde bosque
                "#1E90FF", // Azul Dodger
                "#FF6347", // Tomate
                "#ADFF2F", // Verde amarillento
                "#8B0000", // Rojo oscuro
                "#696969", // Gris oscuro
                "#000000", // Negro
            ],

            modoNocturno: false,

            routingControl: null,
        };
    },

    async mounted() {
        this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
        this.empresaId = this.persona.empresa.id;
        if (this.routePoints.length > 1) {
            let coordenadasPuntos = this.routePoints.map((x) =>
            ({
                lat: x.latUbicacionEntrega,
                lng: x.longUbicacionEntrega,
            }))
            console.log("Coordenadas nada más", coordenadasPuntos)
            this.routingControl = L.Routing.control({

                waypoints: coordenadasPuntos.map((coord) =>
                    L.latLng(coord.lat, coord.lng)
                ),
                show: false,
                showAlternatives: false,
                createMarker: function() { return null; },
                routeWhileDragging: false,
                lineOptions: {
                            styles: [{ color: "#2d6fff", weight: 3, opacity: 0.6 }],
                        },
            }).addTo(this.$refs.map.mapObject);
        }
    },
    beforeUnmount() {
        clearInterval(this.actualizarCoordenadas);
    },
    methods: {
        toggleStyles() {
            this.modoNocturno = !this.modoNocturno;
            this.applyStyles();
        },
        applyStyles() {
            const elements = document.querySelectorAll(
                ".leaflet-layer, .leaflet-control-zoom-in, .leaflet-control-zoom-out, .leaflet-control-attribution"
            );

            elements.forEach((element) => {
                if (this.modoNocturno) {
                    element.style.filter =
                        "invert(100%) hue-rotate(250deg) brightness(80%) contrast(90%)";
                } else {
                    element.style.filter = ""; // Limpia los estilos para regresar a los predeterminados
                }
            });
        },

        onMapReady(mapInstance) {
            this.map = mapInstance;
            //console.log("Instancia del maap ready", mapInstance);
        },
        redirectMap(redireccionCoordenadas) {
            console.log("Redirect", redireccionCoordenadas);
            if (this.map) {
                this.map.flyTo(
                    [redireccionCoordenadas[0], redireccionCoordenadas[1]],
                    16,
                    {
                        duration: 2, // Duración del vuelo
                    }
                );
            }
        },
        updateIconColor(index) {

            return this.customIconIni = L.divIcon({
                html: `<i class="fas fa-map-marker-alt fa-2x" style="color: ${this.polyLineColors[index]}";></i>`,
                iconSize: [40, 45],
                iconAnchor: [16, 16],
            })
        },
        updateTextColor(index) {
            return  `color: ${this.polyLineColors[index]} `
        }
    },
    watch: {
        modoNocturno() {
            this.applyStyles();
        },
        routePoints: {
            handler() {
                let coordenadasPuntos = this.routePoints.map((x) =>
                ({
                    lat: x.latUbicacionEntrega,
                    lng: x.longUbicacionEntrega,
                }))
                if (this.routingControl) {

                    this.$refs.map.mapObject.removeControl(this.routingControl); // Eliminar ruta anterior
                }

                if (coordenadasPuntos.length > 1) {
                    this.routingControl = L.Routing.control({
                        waypoints: coordenadasPuntos.map((coord) => L.latLng(coord.lat, coord.lng)),
                        show: false,
                        showAlternatives: false,
                        createMarker: function() { return null; },
                        lineOptions: {
                            styles: [{ color: "#2d6fff", weight: 3, opacity: 0.6 }],
                        },

                    }).addTo(this.$refs.map.mapObject);
                }
            },
            deep: true,
        },
    },
};
</script>
<style>
.leaflet-div-icon{
    background: transparent !important;
    text-align: center;
    border: none !important;
}

.leaflet-routing-container {
    display: none !important;
}

.leaflet-control-zoom-in span {
    color: black !important;
}

.leaflet-control-zoom-out span {
    color: black !important;
}

.leaflet-popup-content {
    margin: 0 !important;
}

.leaflet-popup-content-wrapper {
    padding: 0 !important;
}
</style>
<style scoped>
.activated:focus {
    border: 2px solid white;
}

.route-map-container {
    height: 60vh;
    max-height: 60vh;
    display: flex;
    flex-direction: column;
}

.route-map-content {
    display: flex;
    height: 100%;
    padding: 0.5rem;
    border-radius: 0.25rem;
}

.map-wrapper {
    flex: 5;
    margin-right: 0.5rem;
}

.route-list-wrapper {
    flex: 1;
    overflow-y: auto;
    border-radius: 0.25rem;
    padding: 0.5rem;
}

.route-item {
    margin-bottom: 0.5rem;
    cursor: pointer;
}

.no-points-message {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.25rem;
}

/* Asegúrate de que el mapa ocupe todo el espacio disponible */
.leaflet-container {
    height: 100%;
    width: 100%;
}
</style>
